import { CreateSpecialOfferInput, SpecialOfferInputError } from "modules/special_offer/state/actionType";

export const FormDataValidation = (
  data: CreateSpecialOfferInput
): SpecialOfferInputError => {
  const errors: SpecialOfferInputError = {};
  if (!data.title) {
    errors.title = "title is required";
  }

  if (!data.status) {
    errors.status = "Status is required";
  }
  if (!data.description) {
    errors.description = "Description is required";
  }
  if (!data.end_date) {
    errors.end_date = "End date is required";
  }
  if (!data.start_date) {
    errors.start_date = "Start date is required";
  }
  if (!data.number_of_days) {
    errors.start_date = "Number of days is required";
  }
  if (!data.membership_duration_id) {
    errors.start_date = "Membership duration is required";
  }
  if (!data.package_id) {
    errors.start_date = "Package date is required";
  }
  return errors;
};
